module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/01-bb1e2013f03ebaab292078f166eba5b2.jpg";